import { useMemo } from 'react';
import { Typography } from '@pocketlaw/tetris';
import { markdownToReact } from 'app/domains/common-ui/Chat';
export function MarkdownContent(props) {
    const { content } = props;
    const markdown = useMemo(() => markdownToReact({
        markdown: content,
    }), [content]);
    return (<Typography $fontSize="small" $fontWeight="regular" $color="text.100">
      {markdown}
    </Typography>);
}
